import React from 'react';
import { AiOutlineForm } from 'react-icons/ai';

const Arrendamiento = () => {
    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Contratos de Arrendamiento</h1>

                <p className='text-xl font-sans text-center'>
                    El contrato de arrendamiento, alquiler o locación (locatio-conductio por su denominación originaria en latín) es un contrato por el cual existe una relación entre dos partes, mediante la cual se obligan de manera recíproca y por un tiempo determinado la cesión de un bien o servicio quedando obligada la parte que aprovecha la posesión a pagar un precio cierto.
                </p>

                <a
                    href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Contratos%20de%20Arrendamiento.`} target="_blank" rel="noopener noreferrer"
                    className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                    <AiOutlineForm size={25} className='inline-block mr-2' />
                    Solicitar
                </a>
            </div>
        </div>
    );
}

export default Arrendamiento;